<template>
  <div>
      <draggable
          class="dragAreaQuestions"
          tag="ul"
          :list="items"
          :group="{ name: 'g3' }"
          item-key="name"
          @end="changeQuestion"
      >
        <template #item="{ index, element }">
          <li class="w-full divide-y divide-gray-200 last:divide-none">
            <div class="flex justify-between pb-2 pt-2 items-center" :data-debug-order="element.order" :data-debug-id="element.id">
              <span class="w-3/4 text-gray-900 text-sm font-light leading-tight">{{ element.text }}</span>
              <span class="flex items-center">
                <RouterLink :to="{ name: 'QuestionSetQuestionShow', params: { question_set_id: element.question_set_id, question_id: element.id } }" class="network-button-color hover:text-gray-900">
                  <EyeIcon class="m-1 h-6 w-6" aria-hidden="true" />
                  <span class="sr-only">, {{ element.id }}</span>
                </RouterLink>
                <button v-if="!isPilot" @click="openQuestionModal(element.question_set_id, element.question_section_id, element.id)" type="button" class="network-button-color hover:text-gray-900">
                  <PencilSquareIcon class="m-1 h-6 w-6" aria-hidden="true" />
                </button>
                <button v-if="!isPilot" @click="destroy(element.id)" type="button" class="network-button-color hover:text-gray-900">
                  <TrashIcon class="m-1 h-6 w-6" aria-hidden="true" />
                </button>
              </span>
            </div>
            <question-children-nested-draggable-question-component :items="element.children" @save-change-question-children="changeQuestion" />
          </li>
        </template>
      </draggable>
  </div>
</template>

<script>
import {EyeIcon, PencilSquareIcon, TrashIcon} from "@heroicons/vue/20/solid";
import draggable from "vuedraggable";
import QuestionChildrenNestedDraggableQuestionComponent from "./QuestionChildrenNestedDraggableQuestionComponent.vue";
import QuestionCreateEditFormComponent from "../Question/QuestionCreateEditFormComponent.vue";
import {useModal, useModalSlot} from "vue-final-modal";
import TwModal from "../TwModal.vue";

export default {
  name: "NestedDraggableQuestionComponent",

  props: {
    items: {
      required: true,
      type: Array,
    },
  },
  components: {
    TwModal,
    QuestionCreateEditFormComponent,
    draggable,
    EyeIcon,
    PencilSquareIcon,
    QuestionChildrenNestedDraggableQuestionComponent,
    TrashIcon,
  },
  computed: {
    isPilot() {
      return this.$store.state.onlyPilotNetwork;
    },
  },
  methods: {
    changeQuestion() {
      this.$emit('save-change-question');
    },
    destroy(id) {
      if(confirm("Do you really want to delete?")) {
        axios.delete(`/member-firm/question-set/question/destroy/${id}`).then((res) => {
          this.$emit('save-change-question');
        }).catch((error) => {
          console.log('error', error)
          this.$notify({ title: "Unsuccessfully", text: error.message });
        })
      }
    },
    openQuestionModal(questionSetId, questionSectionId, questionId) {
      const self = this;
      const { open, close } = useModal({
        component: TwModal,
        attrs: {
          onClose() {
            close()
          },
        },
        slots: {
          default: useModalSlot({
            component: QuestionCreateEditFormComponent,
            attrs: {
              questionSetId: questionSetId,
              questionSectionId: questionSectionId,
              questionId: questionId,
              onReloadIndex() {
                self.$emit('save-change-question');
              },
              onCancel() {
                close()
              },
            },
          })
        },
      });
      open();
    },
  },
};
</script>